var claimDiagnostics = {

	report: function (payload) {
		$.ajax({
			url: '/api/diagnostics/request-timeout',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(payload),
			timeout: 5000,
			error: function () {}
		});
	}

};
